import * as React from 'react';
import { forwardRef } from 'react';
import { AppBar, UserMenu, MenuItemLink, useTranslate } from 'react-admin';
import { Typography, Button, makeStyles, IconButton } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from '../types/Theme';
import { changeTheme } from '../reducer/Actions';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import SettingsIcon from '@material-ui/icons/Settings';

// import Logo from './Logo';

const useStyles = makeStyles({
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    spacer: {
        flex: 1,
    },
});


const CustomAppBar = (props: any) => {
    const classes = useStyles();
    const theme = useSelector((state: AppState) => state.theme);
    const dispatch = useDispatch();

    const onClickLight = () => {
        dispatch(changeTheme('light'));
    }

    const onClickDark = () => {
        dispatch(changeTheme('dark'));
    }

    return (
        <AppBar {...props} elevation={1}>
            <Typography
                variant="h6"
                color="inherit"
                className={classes.title}
                id="react-admin-title"
            />
            {/* <Logo /> */}
            <span className={classes.spacer} />
            {theme === "light" ?
                <span>
                    <IconButton onClick={onClickDark}>
                        <Brightness4Icon />
                    </IconButton>
                </span>
                :
                <span>
                    <IconButton onClick={onClickLight}>
                        <Brightness7Icon />
                    </IconButton>
                </span>
            }
        </AppBar>
    );
};

export default CustomAppBar;